export enum DEFAULT_PREFIX {
    V1 = '/restapi/v1.0',
    V2 = '/restapi/v2.0',
    VIDEO_V1 = '/rcvideo/v1',
    VIDEO_V2 = '/rcvideo/v2',
    VIDEO = '/rcvideo',
    AI = '/ai',
}

export const DEFAULT_PREFIX_KEY = 'V1';

export function hasPrefix(path = ''): boolean {
    return (
        path.startsWith('http://') ||
        path.startsWith('https://') ||
        Object.values(DEFAULT_PREFIX).some(prefixItem => path.startsWith(prefixItem))
    );
}

export function prefixPath(path = '', prefix: string = DEFAULT_PREFIX_KEY): string {
    return typeof prefix !== 'string' || hasPrefix(path)
        ? path
        : (DEFAULT_PREFIX[prefix] || prefix) + path;
}
